import styled from 'styled-components';

const StyledDropdown = styled.div`
	position: relative;
	width: 200px;

	font-family: 'GT Walsheim Pro';
	font-size: 12px;
	color: #000;
`;

const StyledSelectedValue = styled.div`
	padding: 4px;
	border: 1px solid #ccc;
	border-radius: 4px;
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	align-items: center;
	background-color: white;
`;

const StyledArrow = styled.i<{ $direction: 'up' | 'down' }>`
	display: block;
	position: relative;
	width: 20px;
	height: 20px;

	&::after {
		content: '';
		position: absolute;
		inset: 6px;
		border: solid black;
		border-width: 0 3px 3px 0;
		transform: rotate(
			${({ $direction }) => ($direction === 'down' ? '45deg' : '-135deg')}
		);
	}
`;

const StyledOptions = styled.div`
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	border-radius: 4px;
	margin-top: 5px;
	background-color: white;
	z-index: 1;
`;

const StyledOption = styled.div<{ $isSelected: boolean }>`
	padding: 4px;
	cursor: pointer;
	background-color: ${(props) => (props.$isSelected ? '#f0f0f0' : 'white')};

	&:hover {
		background-color: #f0f0f0;
	}

	&:last-child {
		border-radius: 0px 0 4px 4px;
	}
`;

export {
	StyledArrow,
	StyledDropdown,
	StyledOption,
	StyledOptions,
	StyledSelectedValue,
};
